<template>
    <div v-if="symbol" class="flex justify-end" :class="classes">
        <template v-for="button in buttons" :key="button.title">
            <template v-if="button.label == 'JC'">
                <a
                    v-if="jimsCharts.length > 0 && isValidJimChart(button)"
                    :title="button.title"
                    @click="handleClick($event, button)"
                    :href="getChartBookLink(button)"
                    class="btn-table-action"
                    :aria-label="getChartBookLink(button)"
                >
                        {{ button.label }}
                </a>
            </template>
            <a
                v-else
                :title="button.title"
                @click="handleClick($event, button)"
                :href="getLink(button.route, button.parameter, button.label)"
                class="btn-table-action"
                :aria-label="getLink(button.route, button.parameter, button.label)"
            >
                    {{ button.label }}
            </a>
        </template>

        <transaction-modal v-if="modalType === 'transaction'" :transaction-symbol="symbol" :transaction-order-data="extraData" action="add-to-portfolio" :label="symbol" @close="modalType = null"></transaction-modal>
        <order-tickets-form v-if="modalType === 'ordertickets'" :initial-values="{ 'symbol': symbol }" :order-transaction-data="extraData" :is-modal="true" @close="modalType = null"></order-tickets-form>
        <!-- <order-ticket-flash-message v-if="flashMessage.name === 'orderTicketFlashMessage'" @close="flashMessage.name = null"></order-ticket-flash-message> -->
        <custom-quotes-flash-message v-if="flashMessage.name === 'customQuotesFlashMessage'" :data="flashMessage.data" :error="flashMessage.error" @close="flashMessage.name = null"></custom-quotes-flash-message>
        <price-alerts v-if="modalType === 'pricealert'" :price-alert-add="{ 'action': 'add-to-price-alerts', 'symbol': symbol }" @close="modalType = null"></price-alerts>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import CustomQuotesFlashMessage from './FlashMessages/CustomQuotesFlashMessage.vue';
import TransactionModal from './MyFolder/TradeTracker/TransactionModal.vue';
import OrderTicketsForm from './MyFolder/OrderTickets/OrderTicketsForm.vue';
import PriceAlerts from './MyFolder/PriceAlerts.vue';

const buttonDefinitions = [
    { label: 'C', title: 'Chart', route: 'interactive-charts.home', parameter: 'symbol' },
    { label: 'F', title: 'Futures Prices', route: 'quotes.futures', parameter: 'symbol' },
    { label: 'S', title: 'Spread Quote', route: 'quotes.spread', parameter: 'symbol' },
    { label: 'O', title: 'Options Quotes for this Contract', route: 'options.quotes', parameter: 'symbol' },
    { label: 'H', title: 'Options History for this Commodity', route: 'options.history', parameter: 'symbol' },
    { label: 'CA', title: 'Options Calculators', route: 'options.calculator', parameter: 'symbol' },
    { label: 'JC', title: 'Jim\'s Chart', route: 'jims-desk.chart-book.view-jims', parameter: 'symbol' },
    { label: 'T', title: 'Add to Trade Tracker', route: 'my-folder.trade-tracker.index', modal: 'transaction' },
    { label: 'Q', title: 'Add to Custom Quotes', route: 'my-folder.custom-quotes.store', ajax: true, flashMessage: 'customQuotesFlashMessage' },
    { label: 'OT', title: 'Add to Order Ticket', route: 'my-folder.order-tickets.index', modal: 'ordertickets' },
    { label: 'A', title: 'Add to Price Alert', route: 'my-folder.price-alerts.index', modal: 'pricealert' },
];

const groups = defineProps({
    groups: Array,
    classes: Array,
    symbol: String,
    underlyingFuture: String,
    jimsCharts: { type: Array, default: () => [] },
    extraData: Object,
});

const flashMessage = ref({
    name: null,
    data: null,
    error: false,
});

const modalType = ref(null);

const buttons = computed(() => {
    return groups.groups.map(group => buttonDefinitions.find(mButton => mButton.label === group))
        .filter(button => button !== undefined);
});

const isValidJimChart = (button) => {
    const symbol = (groups.underlyingFuture && groups.underlyingFuture != 'N/A') ? groups.underlyingFuture : groups.symbol;
    return (groups.jimsCharts.length > 0 && (groups.jimsCharts.find(mChart => symbol === mChart.symbol)));
};

const getChartBookLink = (button) => {
    const symbol = (groups.underlyingFuture && groups.underlyingFuture != 'N/A') ? groups.underlyingFuture : groups.symbol;
    if (groups.jimsCharts.length > 0) {
        const chart = groups.jimsCharts.find(mChart => symbol === mChart.symbol);
        return `${window.route(button.route, { chart_book: chart.chart_book_id, chart: chart.chart_id })}`;
    }
    return `${window.route('interactive-charts.home', { [button.parameter]: groups[button.parameter] })}`;
};

const getLink = (route, parameter, label) => {
    if (parameter) {
        if ((label == 'C' || label == 'O' || label == 'F') && groups.underlyingFuture && groups.underlyingFuture != 'N/A') {
            return `${window.route(route, { [parameter]: groups.underlyingFuture })}`;
        } else {
            return `${window.route(route, { [parameter]: groups[parameter] })}`;
        }
    }
    return `${window.route(route)}`;
};

const navigate = (e, button) => {
    if (e.ctrlKey) {
        return;
    }
    e.preventDefault();
    if (button.modal) {
        modalType.value = button.modal;
        return;
    } else if (!button.ajax) {
        storeScrollInLocalStorage(button);
        window.location = e.target.href;
    } else {
        return makeRequest(button);
    }
};

const storeScrollInLocalStorage = (button) => {
    const params = {
        scrollY: window.scrollY
    };
    if (button.modal || button.ajax) {
        return;
    }
    window.localStorage.setItem(`scroll-position-${window.location.pathname}`, JSON.stringify(params));
};

const handleClick = (e, button) => {
    if (button.modal || button.ajax) {
        navigate(e, button);
    } else {
        storeScrollInLocalStorage(button);
        if (!e.ctrlKey) {
            e.preventDefault();
            window.location = e.target.href;
        }
    }
};

const makeRequest = (button) => {
    const route = window.route(button.route);
    if (button.label === 'OT') {
        flashMessage.value.name = button.flashMessage;
        return;
    }
    const params = {
        symbol: groups.symbol
    };
    axios.post(route, params)
        .then((response) => {
            flashMessage.value.name = button.flashMessage;
            flashMessage.value.error = false;
            flashMessage.value.data = response.data;
        }).catch((error) => {
            flashMessage.value.name = button.flashMessage;
            flashMessage.value.error = true;
            flashMessage.value.data = error.response;
        })
};
</script>
